import type { ReactNode } from 'react';
import { Navigate } from 'react-router';
import { ApiRequestError } from '../api/client.ts';
import { useMe } from '../api/hooks/useAuth.ts';

export default function RequireAuth({ children }: { children: ReactNode }) {
  const me = useMe();
  if (me.isPending) {
    return <main className="p-8 text-center text-sm text-gray-400">Loading…</main>;
  }
  if (me.isError) {
    if (me.error instanceof ApiRequestError && me.error.status === 401) {
      return <Navigate to="/login" replace />;
    }
    return (
      <main className="p-8 text-center text-sm text-red-600">
        Something went wrong: {me.error.message}
      </main>
    );
  }
  return children;
}
